import e from "react";
import { translate as t } from "@aws-amplify/ui";
import { Flex as o } from "../../../primitives/Flex/Flex.js";
import { Heading as r } from "../../../primitives/Heading/Heading.js";
import { useAuthenticator as n } from "@aws-amplify/ui-react-core";
import { useCustomComponents as a } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as m } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as i } from "../shared/RemoteErrorMessage.js";
import { TwoButtonSubmitFooter as s } from "../shared/TwoButtonSubmitFooter.js";
import { FormFields as l } from "../shared/FormFields.js";
import { RouteContainer as c } from "../RouteContainer/RouteContainer.js";
const d = _ref => {
  let {
    className: r,
    variation: u
  } = _ref;
  const {
      isPending: p
    } = n(e => [e.isPending]),
    {
      handleBlur: f,
      handleChange: E,
      handleSubmit: h
    } = m(),
    {
      components: {
        ConfirmResetPassword: {
          Header: F = d.Header,
          Footer: j = d.Footer
        }
      }
    } = a();
  return e.createElement(c, {
    className: r,
    variation: u
  }, e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmresetpassword": "",
    method: "post",
    onSubmit: h,
    onChange: E,
    onBlur: f
  }, e.createElement(o, {
    as: "fieldset",
    direction: "column",
    isDisabled: p
  }, e.createElement(F, null), e.createElement(o, {
    direction: "column"
  }, e.createElement(l, null)), e.createElement(i, null), e.createElement(s, {
    cancelButtonSendType: "RESEND",
    cancelButtonText: t("Resend Code")
  }), e.createElement(j, null))));
};
d.Header = function () {
  const o = t("Reset your password");
  return e.createElement(r, {
    level: 3
  }, o);
}, d.Footer = function () {
  return null;
};
export { d as ConfirmResetPassword };